import { render, staticRenderFns } from "./EditClausulaservicoPage.vue?vue&type=template&id=1007b15e"
import script from "./EditClausulaservicoPage.vue?vue&type=script&lang=js"
export * from "./EditClausulaservicoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports